// Icon weights
export const FAL = 'fal';
export const FAR = 'far';
export const FAS = 'fas';
// sandbox
export const FAL_ANGLE_LEFT = [FAL, 'angle-left'];
export const FAL_CHECK = [FAL, 'check'];
export const FAR_CHEVRON_UP = [FAR, 'chevron-up'];
export const FAR_CLOCK = [FAR, 'clock'];
export const FAR_EXCLAMATION_TRIANGLE = [FAR, 'triangle-exclamation'];
export const FAR_MESSAGE_PEN = [FAR, 'message-pen'];
export const FAR_UNIVERSITY = [FAR, 'university'];
export const FAR_USER = [FAR, 'user'];
export const FAS_ANGLE_DOWN = [FAS, 'angle-down'];
export const FAS_GLOBE = [FAS, 'globe'];
export const FAS_SIGN_OUT_ALT = [FAS, 'sign-out-alt'];
export const FAS_TIMES = [FAS, 'times'];
export const FAS_USER_CIRCLE = [FAS, 'user-circle'];
// shared
export const FAL_CHEVRON_DOWN = [FAL, 'chevron-down'];
export const FAL_CHEVRON_UP = [FAL, 'chevron-up'];
export const FAR_ARROW_UP_RIGHT = [FAR, 'arrow-up-right-from-square'];
export const FAR_CALENDAR_DAY = [FAR, 'calendar-day'];
export const FAR_CHEVRON_DOWN = [FAR, 'circle-chevron-down'];
export const FAR_CIRCLE_EXCLAMATION = [FAR, 'circle-exclamation'];
export const FAR_DOLLAR_SIGN = [FAR, 'dollar-sign'];
export const FAR_EXTERNAL_LINK = [FAR, 'external-link'];
export const FAR_EYE = [FAR, 'eye'];
export const FAR_EYE_SLASH = [FAR, 'eye-slash'];
export const FAR_INFO_CIRCLE = [FAR, 'info-circle'];
export const FAR_LOCK = [FAR, 'lock'];
export const FAR_PENCIL = [FAR, 'pencil'];
export const FAR_QUESTION_CIRCLE = [FAR, 'question-circle'];
export const FAR_USER_CIRCLE = [FAR, 'user-circle'];
export const FAS_CHECK_CIRCLE = [FAS, 'check-circle'];
export const FAS_CIRCLE_INFO = [FAS, 'circle-info'];
export const FAS_CIRCLE_EXCLAMATION = [FAS, 'circle-exclamation'];
export const FAS_CIRCLE_ONE = [FAS, 'circle-1'];
export const FAS_CIRCLE_TWO = [FAS, 'circle-2'];
export const FAS_EXCLAMATION_TRIANGLE = [FAS, 'triangle-exclamation'];
